import React, { useEffect } from 'react';

const AppPage: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="w-full bg-canvas text-text-primary">
            {/* Hero Section - vertically centered */}
            <section id="hero" className="relative w-full h-screen flex flex-col justify-center items-start px-6 md:px-16 lg:px-24 text-white overflow-hidden">
                {/* Gradient Background */}
                <div
                    className="absolute inset-0 z-0"
                    style={{
                        background: 'linear-gradient(to bottom right, #000000 20%, #0f172a 60%, #312e81 100%)'
                    }}
                />
                {/* Content */}
                <div className="relative z-10">
                    <h1 className="text-5xl md:text-7xl lg:text-8xl font-normal tracking-[-0.02em] text-white leading-[1.1] max-w-5xl">
                        The Nura app
                    </h1>
                    <p className="mt-6 md:mt-8 ml-[3px] text-lg md:text-xl text-text-primary max-w-2xl">
                        Start your 7-Day Free Trial.
                    </p>
                    <a
                        href="https://apps.apple.com/us/app/nura-adaptive-meditation/id6756171302"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-6 md:mt-8 ml-[3px] inline-block min-w-[108px] text-center text-lg text-white whitespace-nowrap bg-transparent border border-white px-5 py-2 rounded-full hover:bg-white hover:text-black transition-colors focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-4 focus:outline-none"
                    >
                        Download for iOS
                    </a>
                </div>
            </section>
        </main>
    );
};

export default AppPage;
